"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupItemsPricing = void 0;
const OrganizationConnectionBaseEntity_1 = require("./OrganizationConnectionBaseEntity");
/**
 * a sepcial price, either amount or percent for an given group to
 * an item (sometimes referd to as package)
 */
class GroupItemsPricing extends OrganizationConnectionBaseEntity_1.OrganizationConnectionBaseEntity {
}
exports.GroupItemsPricing = GroupItemsPricing;
//# sourceMappingURL=GroupItemsPricing.js.map